import API from "../../components/comman/API";
import {
  CustomMessage,
  deCryptFun,
  enCryptFun,
} from "../../components/comman/CustomFunction";
import { authHeader, getLogUserId, getLogEmail, getLogRoleId } from "../../components/comman/MainFunction";
import {
  GET_ALL_CUSTOMERS_URL,
  GET_TYPES_FILTER_URL,
  USERLOG_LIST_URL,
  GET_ALL_PROJECTS_URL,
  GET_ALL_STATE_LIST_URL,
  GET_PERDIAM_VALUE_BY_ID_URL,
  USERS_BY_ID_URL,
  GET_USER_NTE_NOTIFICATIONS,
} from "../../constants/ApiRoute";
import { ALL_STATE_INITIAL } from "../store/InitialStore";
import { userRole as roledata } from "../../components/comman/Constant";
import {
  ALL_CUSTOMERS_LIST,
  TYPE_LIST_IN_FILTER,
  USER_LIST_TYPE,
  ALL_PROJECTS_LIST,
  ALL_STATE_LIST,
  PER_DIEM_LIST,
  USER_ACTIVE_TYPE,
  CHECK_USER,
  INNER_NOTIFICATION_DETAILS_REUX
} from "./ActionType";
import { useState } from "react";

export function getAlluserList() {
  return (dispatch) => {
    const options = {
      method: "GET",
      headers: authHeader(),
      url: USERLOG_LIST_URL,
    };
    API(options)
      .then((response) => {
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status == "Success") {
          dispatch({
            type: USER_LIST_TYPE,
            payload: response?.data,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          //       showToast(v.message, "error");
        }
      });
  };
}

export function getAllTypeList(id) {
  return (dispatch) => {
    let data = {
      categoryId: id?id:-1,
    };
    const options = {
      method: "GET",
      headers: authHeader(),
      url: GET_TYPES_FILTER_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    API(options)
      .then((response) => {
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status == "Success") {
          dispatch({
            type: TYPE_LIST_IN_FILTER,
            payload: response.data,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          //       showToast(v.message, "error");
        }
      });
  };
}
export function getAllNotificationDetails() {
  return (dispatch) => {
    let data = {
      userId: getLogUserId(),
    };
    const options = {
      method: "GET",
      headers: authHeader(),
      url: GET_USER_NTE_NOTIFICATIONS,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    API(options)
      .then((response) => {
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status == "Success") {
          console.log(parsedResponse,'parsedResponseparsedResponse')
          dispatch({
            type: INNER_NOTIFICATION_DETAILS_REUX,
            payload: parsedResponse?.message,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          dispatch({
            type: INNER_NOTIFICATION_DETAILS_REUX,
            payload: [],
          });
          //       showToast(v.message, "error");
        }
      });
  };
}

export function getAllCustomersList() {
  return (dispatch) => {
    const options = {
      method: "GET",
      headers: authHeader(),
      url: GET_ALL_CUSTOMERS_URL,
    };
    API(options)
      .then((response) => {
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status == "Success") {
          dispatch({
            type: ALL_CUSTOMERS_LIST,
            payload: response.data,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          //       showToast(v.message, "error");
        }
      });
  };
}

export function getAllProjectsList() {
  return (dispatch) => {
    const options = {
      method: "GET",
      headers: authHeader(),
      url: GET_ALL_PROJECTS_URL,
    };
    API(options)
      .then((response) => {
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status == "Success") {
          dispatch({
            type: ALL_PROJECTS_LIST,
            payload: response.data,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          //       showToast(v.message, "error");
        }
      });
  };
}

export function getAllStatesList() {
  return (dispatch) => {
    const options = {
      method: "GET",
      headers: authHeader(),
      url: GET_ALL_STATE_LIST_URL,
    };
    API(options)
      .then((response) => {
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status == "Success") {
          dispatch({
            type: ALL_STATE_LIST,
            payload: response.data,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          //       showToast(v.message, "error");
        }
      });
  };
}
export function getPerDiemList(pid, brokerId) {
  let data = {
    projectId: pid,
    userId: brokerId ? brokerId : ""
  };
  return (dispatch) => {
    const options = {
      method: "GET",
      headers: authHeader(),
      url: GET_PERDIAM_VALUE_BY_ID_URL,
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    API(options)
      .then((response) => {
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status == "Success") {
          dispatch({
            type: PER_DIEM_LIST,
            payload: response.data,
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          //       showToast(v.message, "error");
        }
      });
  };
}

export function getLoggedUserDetails() {
  return (dispatch) => {
     const d1 = {
       userId: getLogUserId(),
     };
     const config = {
       method: "GET",
       url: USERS_BY_ID_URL,
       headers: authHeader(),
       params: {
         webString: enCryptFun(JSON.stringify(d1)),
       },
     };

    
    API(config)
      .then((response) => {
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status == "Success") {
          const { AccountActive,UserRole } = parsedResponse.data[0];
          const selectedRoles = roledata
          .filter((role) => UserRole.includes(role.id))
          .map((role) => role.role);
        let roleen = enCryptFun(JSON.stringify(selectedRoles));
        localStorage.setItem("ROLE", roleen);
          let d = {
            userId: getLogUserId(),
            active: AccountActive,
          };
          dispatch({
            type: USER_ACTIVE_TYPE,
            payload:  enCryptFun(JSON.stringify(d)),
          });
        }
      })
      .catch((error) => {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          //       showToast(v.message, "error");
        }
      });
  };
}

export function getUserCheckOLD() {
  return (dispatch) => {

    const d1 = {
      userId: getLogUserId(),
    };
    const config = {
      method: "GET",
      url: USERS_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(d1)),
      },
    };

   
   API(config)
     .then((response) => {
       let decryptedResponse = deCryptFun(response.data);
       const parsedResponse = JSON.parse(decryptedResponse);
       if (parsedResponse.status == "Success") {
         const { UserId, Email, UserRole } = parsedResponse.data[0];
         let d = {
           userId: getLogUserId(),
           email: Email,
           role: UserRole
         };

         var dataOutput = {};

         //Email Check
         if(Email != getLogEmail()){

          dataOutput = {
            type: "error",
            message: "Your email has been changed by the admin."
          };

         }

         if(UserRole && getLogRoleId() && UserRole.split(",").length != getLogRoleId().split(",").length){

          dataOutput = {
            type: "error",
            message: "Your user role has been changed by the admin."
          };

         }

         dispatch({
          type: CHECK_USER,
          payload:  enCryptFun(JSON.stringify(dataOutput)),
        })

       }
     })
     .catch((error) => {
       if (error.response) {
         let { data } = error.response;
         let p = deCryptFun(data);
         let v = JSON.parse(p);
         //       showToast(v.message, "error");
       }
     });


  };
}